import _SvgIcon from "@mui/material/SvgIcon";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export function NoMarkingIcon(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13776_15144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.76923 2.34619C3.19407 2.34619 3.53846 2.69059 3.53846 3.11542V17.9872C3.53846 18.4121 3.19407 18.7564 2.76923 18.7564C2.3444 18.7564 2 18.4121 2 17.9872V3.11542C2 2.69059 2.3444 2.34619 2.76923 2.34619Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94872 8.50004C10.3736 8.50004 10.7179 8.84443 10.7179 9.26927V11.8334C10.7179 12.2582 10.3736 12.6026 9.94872 12.6026C9.52388 12.6026 9.17949 12.2582 9.17949 11.8334V9.26927C9.17949 8.84443 9.52388 8.50004 9.94872 8.50004Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1282 2.34619C17.553 2.34619 17.8974 2.69059 17.8974 3.11542L17.9661 8.50004C17.9661 8.92487 17.6217 9.26927 17.1969 9.26927C16.7721 9.26927 16.4277 8.92487 16.4277 8.50004L16.359 3.11542C16.359 2.69059 16.7034 2.34619 17.1282 2.34619Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94872 2.34619C10.3736 2.34619 10.7179 2.69059 10.7179 3.11542V5.67952C10.7179 6.10436 10.3736 6.44876 9.94872 6.44876C9.52388 6.44876 9.17949 6.10436 9.17949 5.67952V3.11542C9.17949 2.69059 9.52388 2.34619 9.94872 2.34619Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3594 18.0298H16.362M14.9922 14.2693C15.1027 13.9551 15.3208 13.6902 15.608 13.5215C15.8951 13.3527 16.2327 13.291 16.5609 13.3473C16.8892 13.4036 17.1869 13.5743 17.4014 13.8291C17.6159 14.0839 17.7333 14.4063 17.7328 14.7394C17.7328 15.6796 16.3225 16.1496 16.3225 16.1496M21.0599 15.6794C21.0599 18.2756 18.9553 20.3802 16.3591 20.3802C13.7628 20.3802 11.6582 18.2756 11.6582 15.6794C11.6582 13.0832 13.7628 10.9785 16.3591 10.9785C18.9553 10.9785 21.0599 13.0832 21.0599 15.6794Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.23077"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13776_15144"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: "24",
    width: "24"
  }))));
}